// extracted by mini-css-extract-plugin
export default {"button":"No-z","reviewSort":"Oo-z"};